import verticalRhythm from 'compass-vertical-rhythm';
import ms from 'modularscale';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
} // theme.styles object for use with typography.js-generated theme object
// similar to typography.js style output, with these differences
// - only includes styles for markdown elements
// - does not include color styles
// - does not include responsive styles


var heading = {
  fontFamily: 'heading',
  lineHeight: 'heading',
  fontWeight: 'heading'
};
var baseStyles = {
  root: {
    fontFamily: 'body',
    fontSize: 2,
    fontWeight: 'body',
    lineHeight: 'body'
  },
  img: {
    maxWidth: '100%'
  },
  h1: _extends({
    fontSize: 5
  }, heading),
  h2: _extends({
    fontSize: 4
  }, heading),
  h3: _extends({
    fontSize: 3
  }, heading),
  h4: _extends({
    fontSize: 2
  }, heading),
  h5: _extends({
    fontSize: 1
  }, heading),
  h6: _extends({
    fontSize: 0
  }, heading),
  ul: {
    listStylePosition: 'outside',
    listStyleImage: 'none',
    ml: 3
  },
  ol: {
    listStylePosition: 'outside',
    listStyleImage: 'none',
    ml: 3
  },
  li: {
    mb: 2,
    pl: 0,
    ol: {
      my: 2,
      ml: 3
    },
    ul: {
      my: 2,
      ml: 3
    },
    p: {
      mb: 2
    }
  },
  p: {},
  table: {
    borderCollapse: 'collapse',
    width: '100%'
  },
  th: {
    textAlign: 'left',
    borderBottom: '1px solid',
    px: 2,
    py: 1,
    ':first-child': {
      pl: 0
    },
    ':last-child': {
      pr: 0
    }
  },
  td: {
    textAlign: 'left',
    borderBottom: '1px solid',
    px: 2,
    py: 1,
    mt: '-1px',
    ':first-child': {
      pl: 0
    },
    ':last-child': {
      pr: 0
    }
  },
  blockquote: {
    mx: 3
  },
  hr: {
    border: 0,
    borderBottom: '1px solid',
    mt: '-1px',
    mb: 3
  },
  b: {
    fontWeight: 'bold'
  },
  strong: {
    fontWeight: 'bold'
  },
  code: {
    fontSize: '85%'
  },
  pre: {
    fontSize: '85%',
    padding: 3
  }
};
var headings = ['h6', 'h5', 'h4', 'h3', 'h2', 'h1'];
var blockElements = [].concat(headings, ['ul', 'ol', 'p', 'pre', 'table', 'blockquote', 'img', 'hr']);

var styles = _extends({}, baseStyles, blockElements.reduce(function (style, tag) {
  var _extends2;

  return _extends({}, style, (_extends2 = {}, _extends2[tag] = _extends({
    padding: 0,
    margin: 0,
    marginBottom: 3
  }, baseStyles[tag]), _extends2));
}, {}));

var unwantedTypographyOptions = ['headerColor', 'bodyColor', 'overrideStyles', 'overrideThemeStyles', 'plugins']; // - uses unitless values
// - creates base theme object
// - uses a static theme.styles object for consumption in theme-ui
// - ignores overrideThemeStyles
// - does not include color styles
// - should be mostly compatible with existing typography.js themes

var defaults = {
  baseFontSize: 16,
  baseLineHeight: 1.45,
  headerLineHeight: 1.1,
  scaleRatio: 2,
  googleFonts: [],
  headerFontFamily: ['-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'sans-serif'],
  bodyFontFamily: ['georgia', 'serif'],
  headerWeight: 'bold',
  bodyWeight: 'normal',
  boldWeight: 'bold',
  includeNormalize: true,
  blockMarginBottom: 1
};
var toUnitless = parseFloat;

var getScale = function getScale(opts) {
  return function (value) {
    return ms(value, opts.scaleRatio) * opts.baseFontSize;
  };
};

var getSpace = function getSpace(rhythm, opts) {
  var n = toUnitless(rhythm.rhythm(opts.blockMarginBottom));
  return [0, 1 / 4, 1 / 2, 1, 2, 4, 8].map(function (v) {
    return v * n;
  });
}; // genericFontFamilies, wrapFontFamily adapted from typography.js
// Wrap font names in quotes, unless the font name is actually a keyword.
// See https://stackoverflow.com/a/13752149 and https://www.w3.org/TR/CSS2/fonts.html#font-family-prop


var genericFontFamilies = ['inherit', 'default', 'serif', 'sans-serif', 'monospace', 'fantasy', 'cursive', '-apple-system', 'system-ui'];

var wrapFontFamily = function wrapFontFamily(fontFamily) {
  return genericFontFamilies.includes(fontFamily) ? fontFamily : "'" + fontFamily + "'";
};

var stackFonts = function stackFonts(fonts) {
  return fonts.map(wrapFontFamily).join(', ');
};

var getFonts = function getFonts(rhythm, opts) {
  var body = stackFonts(opts.bodyFontFamily);
  var heading = stackFonts(opts.headerFontFamily);
  return {
    body: body,
    heading: heading
  };
};

var getFontSizes = function getFontSizes(rhythm, opts) {
  var scale = getScale(opts);
  return [-1.5 / 5, -1 / 5, 0, 2 / 5, 3 / 5, 1].map(scale);
};

var getLineHeights = function getLineHeights(rhythm, opts) {
  var body = opts.baseLineHeight;
  var heading = opts.headerLineHeight;
  return {
    body: body,
    heading: heading
  };
};

var getFontWeights = function getFontWeights(rhythm, opts) {
  return {
    body: opts.bodyWeight,
    bold: opts.boldWeight,
    heading: opts.headerWeight
  };
};

var pruneOptionsFromUnwanted = function pruneOptionsFromUnwanted(opts) {
  if (opts == null) {
    return opts;
  }

  var res = _extends({}, opts);

  for (var _iterator = _createForOfIteratorHelperLoose(unwantedTypographyOptions), _step; !(_step = _iterator()).done;) {
    var k = _step.value;
    delete res[k];
  }

  return res;
};

var toUnitlessOptions = function toUnitlessOptions(opts) {
  // Return nullish opts
  // Or opts with nullish baseFontSize (intentional override)
  // Or opts with unset baseFontSize (just not defined)
  if (opts == null || opts.baseFontSize == null) {
    return opts;
  }

  return _extends({}, opts, {
    baseFontSize: toUnitless(opts.baseFontSize)
  });
};

var toTheme = function toTheme(options) {
  var opts = _extends({}, defaults, toUnitlessOptions( // enforce unitless values
  pruneOptionsFromUnwanted(options)));

  var rhythmOpts = _extends({}, opts, {
    rhythmUnit: 'px',
    baseFontSize: String(opts.baseFontSize)
  });

  var rhythm = verticalRhythm(rhythmOpts);
  return {
    space: getSpace(rhythm, opts),
    fonts: getFonts(rhythm, opts),
    fontSizes: getFontSizes(rhythm, opts),
    fontWeights: getFontWeights(rhythm, opts),
    lineHeights: getLineHeights(rhythm, opts),
    styles: styles,
    typography: _extends({}, rhythm, {
      options: opts
    })
  };
};

export { styles, toTheme };